<template>
    <div class="pl-5">
        <h1>Wordpress plugin</h1>
        <p style="font-style: italic; font-weight: bold;">NB! Wordpress plugin was updated on 2021-09-20 to new v2 version. Please update your plugin if you have older version of Wordpress plugin.</p>
        <p>
            Tarkpay offers a Wordpress plugin for Woocommerce.<br />
            You can download the plugin:
            <a href="/static/wordpress-plugin/tarkpay-payment.zip">here</a>
        </p>
        <p>
            1. The first step is to upload the plugin to wp-content/plugins folder in your Wordpress installation.
        </p>
        <p>
            2. Activate th plugin in Wordpress at the plugins section
            <br />
            <img src="/static/img/wordpress-1.png" />
            <br />
        </p>
        <p>
            3. Under the Woocommerce's settings, go to checkout/payment settings and choose Tarkpay.
        </p>
        <p>
            3.1 First, make sure that the Tarkpays payment method is enabled
        </p>
        <p>
            3.2 After making sure the method is enabled, you can choose if to use Tarkpay in Sandbox mode or LIVE
            environment.<br />
            Then fill in the necessary credentials (client ID and API key).
            <br />
            <img src="/static/img/wordpress-2.png" />
        </p>
        <p>
            4.Go to checkout and find out if everything works fine. The result should look similar to next picture.
            <br />
            <img src="/static/img/wordpress-3.png" />
        </p>
    </div>
</template>

<script>
export default {
    name: "wordpress-plugin-page"
};
</script>

<style scoped></style>
